<template>
    <div class="row document-editor">
      <div class="col">
        <form
            class="form-inline py-2 justify-content-between align-items-center"
            @submit.prevent
          >
            <div class="d-flex col-8 align-items-center" >
              <button
                type="button"
                class="btn btn-back btn-lg"
                @click="onCancel"
              >
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <h2 class="ml-4">{{name}}</h2>
            </div>
            <div class="col-4">
              <button
                type="button"
                class="btn btn-secondary ml-2"
                @click="onCancel"
              >Отменить</button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                @click="onSave"
              >Сохранить</button>
            </div>
          </form>
        <div
        class="document-editor__ckeditor mt-4"
        :style="{width: !orientation ? '210mm' : '297mm'}">
            <ckeditor v-model="body" :config="editorConfig"></ckeditor>
        </div>
      </div>
    </div>
</template>

<script>
import ckeditor from '../../components/ckeditor'
import api from '../../api'

const editorConfig = {
  autoGrow_minHeight: 600,
  autoGrow_onStartup: true,
  extraPlugins: 'justify,font,colorbutton,liststyle,preview,autogrow,table,tableresize',
  language: 'ru',
  allowedContent: true,
  toolbarGroups: [
    { name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
    { name: 'insert', groups: [] },
    { name: 'forms', groups: ['forms'] },
    { name: 'tools', groups: ['tools'] },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    '/',
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
    { name: 'styles', groups: ['styles'] },
    { name: 'colors', groups: ['colors'] }
  ]
}

export default {
  name: 'Editor',
  components: {
    ckeditor
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      orientation: false,
      name: '',
      body: '',
      editorConfig
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Редактирование документа')
    })
  },
  async created () {
    await this.setDocumentData()
  },
  methods: {
    async setDocumentData () {
      try {
        const response = await api.get.document(this.id)
        const doc = response.data.data.document
        this.name = doc.name
        this.orientation = doc.orientation
        this.body = doc.body
      } catch {
        // ignore
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onSave () {
      try {
        await api.post.editDocument(this.id, this.body)
        this.$notify({
          message: `Документ ${this.name} сохранен`,
          type: 'success'
        })
      } catch {
        this.$notify({
          message: 'Ошибка сохранения документа',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.document-editor{
  &__ckeditor{
    position: relative;
    background-color: #fff;
  }

  .cke_top{
    position: sticky;
    top: 50px;
  }
}
</style>
